import { useMutation } from "@tanstack/react-query";
import { usersApi } from "../../api/users";

export const useSetUserRole = () =>
  useMutation({
    mutationFn: usersApi.setRole,
  });

export const useRecalculateElo = () =>
  useMutation({
    mutationFn: usersApi.recalculateElo,
  });
